import React from 'react';
import { AppAutocomplete, AppBadge } from '../ui';
import { useKkpClientSearch } from '../../hooks/useKkpClientSearch';

const CLIENT_SOURCE_BADGE = {
  dolibarr: { label: 'Dolibarr', variant: 'info' },
  planning: { label: 'Planning', variant: 'neutral' },
  plan_de_com: { label: 'Plan de com', variant: 'neutral' },
};

function clientSourceBadge(client) {
  const known = CLIENT_SOURCE_BADGE[client?.source];
  if (known) {
    return known;
  }
  if (Number(client?.id) > 0) {
    return CLIENT_SOURCE_BADGE.dolibarr;
  }
  return { label: 'Hors Dolibarr', variant: 'neutral' };
}

const KkpClientAutocomplete = ({
  value,
  onChange,
  onSelect,
  onKeyDown,
  onBlur,
  autoFocus = false,
  className = '',
  inputClassName = '',
  placeholder = 'Saisie libre ou recherche client Dolibarr…',
  size = 'md',
  dolibarrOnly = false,
  required = false,
}) => {
  const { suggestions, loading } = useKkpClientSearch(value, { dolibarrOnly });
  const displaySuggestions = dolibarrOnly
    ? suggestions.filter((client) => Number(client.id) > 0)
    : suggestions;

  return (
    <AppAutocomplete
      className={`kkp-client-autocomplete ${className}`.trim()}
      inputClassName={inputClassName}
      size={size === 'sm' ? 'sm' : undefined}
      value={value}
      onChange={onChange}
      onSelect={(client) => {
        if (onSelect) {
          onSelect(client);
        } else {
          onChange(client.nom ?? '');
        }
      }}
      onKeyDown={onKeyDown}
      onBlur={onBlur}
      autoFocus={autoFocus}
      required={required}
      items={displaySuggestions}
      loading={loading}
      getItemKey={(client) => `${client.id}-${client.nom}`}
      renderItem={(client) => {
        const source = clientSourceBadge(client);
        return (
          <>
            <AppBadge variant={source.variant} pill className="me-2">
              {source.label}
            </AppBadge>
            {client.nom}
            {client.siret && (
              <span className="text-secondary-light ms-2 text-sm">
                SIRET {client.siret}
              </span>
            )}
            {client.entreprise && client.entreprise !== client.nom && (
              <span className="text-secondary-light ms-2 text-sm">
                — {client.entreprise}
              </span>
            )}
          </>
        );
      }}
      placeholder={placeholder}
      emptyMessage={dolibarrOnly
        ? 'Aucun client Dolibarr trouvé'
        : 'Aucun client trouvé dans le planning ni dans Dolibarr'}
      loadingLabel="Recherche Dolibarr…"
    />
  );
};

export default KkpClientAutocomplete;
